// extracted by mini-css-extract-plugin
module.exports = {"categoriesInfo":"CategoryInfo_categoriesInfo__2N7z-","title":"CategoryInfo_title__2stz8"};